import { MessageCircle } from "lucide-react";

export interface NavLink {
  title: string;
  href: string;
  isExternal?: boolean;
}

export const NAV_LINKS: NavLink[] = [
  { title: "Home", href: "/" },
  { title: "Treatments", href: "/treatments/" }, // Handled specially in Desktop, but standard in Mobile
  { title: "Hospitals", href: "/hospitals/" },
  { title: "Doctors", href: "/doctors/" },
  { title: "Articles", href: "/blog/" },
  { title: "Contact Us", href: "/contact/" },
];

export const CTA_LINKS = {
  whatsapp: {
    title: "WhatsApp Us",
    icon: MessageCircle,
  },
  quote: {
    title: "Get Free Quote",
    href: "/contact/",
  },
};
